$(document).ready(function () {
  if (typeof $('.woocommerce-table__line-item.order_item') !== 'undefined') {
    $('.woocommerce-table__line-item.order_item').each(function () {
      $(this).find('ul.wc-item-meta li').each(function () {
        if ($(this).find('strong').text() == 'fee_type:') {
          $(this).remove();
        }
      })
    })
  }
});